import { Component, OnInit } from '@angular/core';
import { MeduskladisnicaService } from '..//meduskladisnica/meduskladisnica.service';
import { moduli } from '../../config';
import moment from 'moment';
import notify from 'devextreme/ui/notify';
import { PdfZaMeduskladisniceService } from 'src/app/pdf-ovi/pdfZaMeduskladisnice.service';
import { custom } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-meduskladisnica-mrvice',
  templateUrl: './meduskladisnica-mrvice.component.html',
  styleUrls: ['./meduskladisnica-mrvice.component.scss'],
  providers: [MeduskladisnicaService]
})
export class MeduskladisnicaMrviceComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');

  meduskladisnicePopis = [];
  stavke: any = [];
  poslovnice = [];
  poslovniceOtpreme: any = [];
  poslovnicePrijema: any = [];
  id_odabranoSkladiste: any;
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');
  odabranoSkladiste_id: any;
  odabranoZaglavlje_id: number;

  prikazi: any = [
    {idprikaz: 1, pr_naziv: 'DA'},
    {idprikaz: 0, pr_naziv: 'NE'}
  ];

  // ZA DODAVANJE STAVKI
  idProizvoda: any;
  lotBroj: any;
  kolicina: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  popupAddPalleteVisible: boolean = false;
  odabraniProizvod: any;
  sviLotovi: any = [];
  odabraniLot: any;

  artiklPopis: any = [];
  lotbrojeviPopis: any = [];
  sviArtikli_poslovnica: any = [];
  sviLotovi_poslovnica: any = [];
  sviLotovi_artikla: any = [];

  sifraArtikla: any;


  dozvoliUredivanje: any = false;
  poruka: string;
  disableGumb: boolean = false;
  naslov: string;

  isLoading: boolean = true;

  constructor(
    private service: MeduskladisnicaService,
    private meduskladisnicaService: PdfZaMeduskladisniceService
  ) {

    this.dohvatiMeduskladisnice();

    this.dohvatiPoslovnice();
    this.dohvatiPodatke();

    this.onShowing = this.onShowing.bind(this);

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().meduskladisnicaZaMrvice;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit(): void {
  }

  pretrazi(){
    this.dohvatiMeduskladisnice();
  }

  dohvatiMeduskladisnice(){
    this.poruka = 'Učitavanje...';
    this.disableGumb = true;
    this.meduskladisnicePopis = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      datumod: this.datumOdFormatiran,
      datumdo: this.datumDoFormatiran,
      poslovnica_po_id: this.id_odabranoSkladiste,
      napomena2: 'MSKLADMRVICE'
    };
    //console.log(podaciZaSlanje);
    this.service.meduskladisnice_popis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.disableGumb = false;
      if (res.success === true) {
        this.meduskladisnicePopis = res.data;
      }
      if (res.data.length > 0) {
        this.poruka = 'Učitavanje...';
      }else{
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  dodajZaglavlje(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      datum: moment(e.data.pz_datum).format('YYYY-MM-DD'),
      poslovnica_po_id: e.data.poslovnica_po_id,
      poslovnica_po_id2: e.data.poslovnica_po_id2,
      napomena2: 'MSKLADMRVICE'
    }
    //console.log(podaciZaSlanje);
    this.service.dodaj_meduskladisnicu(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješno dodana međuskladišnica za mrvice.', 'success', 3000);
        this.dohvatiMeduskladisnice();
      }else{
        notify(res.message, 'error', 3000);
        this.dohvatiMeduskladisnice();
      }
    });
  }

  urediZaglavlje(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: e.data.pz_id,
      datum: moment(e.data.pz_datum).format('YYYY-MM-DD'),
      poslovnica_po_id: e.data.poslovnica_po_id,
      poslovnica_po_id2: e.data.poslovnica_po_id2,
      prijevoznik: e.data.partner_pa_id_vezni
    };
    //console.log(podaciZaSlanje);
    this.service.uredi_meduskladisnicu(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiMeduskladisnice();
        notify('Uspješno uređena međuskladišnica.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  /* dodaj paletu */
  dodajStavku() {
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: this.odabranoZaglavlje_id,
      idartikl: this.idProizvoda,
      ar_lot: this.lotBroj,
      ps_izlaz: this.kolicina
    }
    //console.log(podaciZaSlanje);
    this.service.tmpprometstavkeDodaj(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješno dodana paleta.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
      this.dohvatiStavke();
    });
    

    this.odabraniProizvod = '';
    this.odabraniLot = '';
    this.lotBroj = '';
    this.kolicina = null;

    this.popupAddPalleteVisible = false;
  }

  urediStavku(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: this.odabranoZaglavlje_id,
      idartikl: e.data.artikl_ar_id,
      idtmpprometstavke: e.data.ps_id,
      ps_izlaz: e.data.ps_izlaz,
      ar_lot: e.data.ar_lot
    };
    //console.log(podaciZaSlanje);
    this.service.tmpprometstavkeUredi(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješno uređena stavka.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
      this.dohvatiStavke();
    });
  }

  obrisiStavku(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: this.odabranoZaglavlje_id,
      idtmpprometstavke: e.data.ps_id
    };
    //console.log(podaciZaSlanje);
    this.service.tmpprometstavkeObrisi(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješna obrisana stavka.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
      this.dohvatiStavke();
    });
  }

  obrisiDokument(e){
    //console.log(e.data);
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      pz_id: e.data.pz_id,
    };
    //console.log(podaciZaSlanje);
    this.service.obrisi_meduskladisnicu(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Dokument uspješno obrisan.', 'success', 3000);
      }
      this.dohvatiMeduskladisnice();
    });
  }

  stornirajDokument(e){
    //console.log(e);
    //this.zadnjId = null;
    let myDialog = custom({
      title: "Storniranje",
      messageHtml: "Jeste li sigurni da želite stornirati dokument i sve vezano uz njega?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        this.service.storniraj_meduskladisnicu({
          'idkorisnik': this.idkorisnik,
          'idfirma': this.idfirma,
          'pz_id': e.data.pz_id
        }).subscribe(res=>{
          if(res.success == true){
            this.dohvatiMeduskladisnice();
            notify('Uspješno ste stornirali dokument.', 'success');
          } else {
            notify(res.message, 'error');
          }
        });
      }else{  }
    });
  }

  zavrsiDokument(e) {
    //console.log(e);
    //this.zadnjId = null;
    let myDialog = custom({
      title: "Završavanje",
      messageHtml: "Jeste li sigurni da želite završiti dokument?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        let podaciZaSlanje = {
          idfirma: this.idfirma,
          idkorisnik: this.idkorisnik,
          pz_id: e.data.pz_id
        };
        //console.log(podaciZaSlanje);
        this.service.zavrsi_meduskladisnicu_mrvice(podaciZaSlanje).subscribe((res) => {
          //console.log(res);
          if (res.success === true) {
            notify('Dokument uspješno završen.', 'success', 3000);
          }else{
            notify(res.message, 'error', 3000);
          }
          this.dohvatiMeduskladisnice();
        });
      }else{  }
    });
  }

  dohvatiPodatke(){
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token
    };
    //console.log(podaciZaSlanje);
    this.service.mskladMrviceDepend(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.artiklPopis = res.data.artiklPopis;
        this.lotbrojeviPopis = res.data.lotbrojeviPopis;
        this.poslovniceOtpreme = res.data.poslovnicaPopisOtprema;
        this.poslovnicePrijema = res.data.poslovnicaPopisPrijem;
      }
    });
  }

  dohvatiPoslovnice() {
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
    };
    this.poslovnice = [];
    this.service.poslovnicaPopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.poslovnice = res.data;
      }
    });
  }

  onEditingStart(e) {
    //console.log(e.data);
    this.naslov = "Uredi međuskladišnicu";

    if(e.data.pz_status == 'Z'){
      this.dozvoliUredivanje = false;
    }else{
      this.dozvoliUredivanje = true;
    }
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
  }
  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
  }

  promjenaSkladista(e) {
    this.id_odabranoSkladiste = e.value;
  }

  onSelectionChanged(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);

    this.isLoading = true;

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      this.odabranoSkladiste_id = e.selectedRowsData[0].poslovnica_po_id;
      this.odabranoZaglavlje_id = e.selectedRowsData[0].pz_id;
      

      this.filtrirajArtikleZaPoslovnicu().then((artPosl: any) =>{
        //console.log('res artPosl: ', artPosl);
        if (artPosl) {
          this.isLoading = false;
        }
      });

      this.filtrirajLotoveZaPoslovnicu().then((lotPosl: any) =>{
        //console.log('res lotPosl: ', lotPosl);
        if (lotPosl) {
          
        }
      });

      this.dohvatiStavke();
    }
  }

  dohvatiStavke() {
    this.stavke = [];
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      pz_id: this.odabranoZaglavlje_id,
    };
    //console.log(podaciZaSlanje);

    this.service.tmpprometstavkePopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.isLoading = false;
      if (res.success === true) {
        this.stavke = res.data;
      }
    });
      
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onRowClick(e) {
    if (
      e.rowType === 'data' &&
      e.handled !== true &&
      e.event.target.className !== 'dx-button-text'
    ) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onShowing(e: any){
    e.component.option("title", this.naslov);
  }

  onInitNewRow(e: any){
    //console.log(e);
    this.dozvoliUredivanje = true;
    this.naslov = 'Dodaj međuskladišnicu';
    e.data.pz_datum = moment();
  }

  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType === 'data') {
      if (options.column.dataField === "pz_status"){
        if (options.value == 'I') {
          options.cellElement.classList.add('circleYellow');
        }
        if (options.value == 'U') {
          options.cellElement.classList.add('circleBlue');
        }
        if (options.value == 'S') {
          options.cellElement.classList.add('circleRed');
        }
        if (options.value == 'Z') {
          options.cellElement.classList.add('circleGreen');
        }
      }
    }
  }

  calculateSortValue(rowData: any) {
    // If your receipt numbers are in format like "PZ-2024-001"
    const receiptNumber = rowData.pz_broj;
    
    // Remove any non-numeric characters and convert to number
    // This will sort based on the numeric value
    return parseInt(receiptNumber.replace(/\D/g, ''));
    
    // OR if you want to sort by the full string but in a specific way:
    // return receiptNumber.padStart(10, '0');
  }

  addPalletePopup() {
    this.popupAddPalleteVisible = true;

    //this.dohvatiSveProizvode();

    this.odabraniProizvod = '';
    this.odabraniLot = '';
    this.lotBroj = '';
    this.kolicina = null;
  }

  filtrirajArtikleZaPoslovnicu(){
    return new Promise((resolve) => {
      this.sviArtikli_poslovnica = this.artiklPopis.filter(p => p.idposlovnica === this.odabranoSkladiste_id);
      //console.log(this.sviArtikli_poslovnica);
      resolve(1);
    })
  }

  filtrirajLotoveZaPoslovnicu(){
    return new Promise((resolve) => {
      this.sviLotovi_poslovnica = this.lotbrojeviPopis.filter(p => p.poslovnica_po_id === this.odabranoSkladiste_id);
      //console.log(this.sviLotovi_poslovnica);
      resolve(1);
    })
  }  

  onChangeProizvodId(e) {
      //console.log(e);
      this.lotBroj = '';
      this.idProizvoda = e.value.ar_id; //e.value.id;
      this.sifraArtikla = e.value.ar_sifra; //e.value.sifra;
  
      //stari nacin dohvacanja koji je pravio problem sa sirovinama (nije bilo lot-ova)
      /*
      if (this.idProizvoda !== null) {
        this.dohvatiSveLotove(this.idProizvoda);
      }
      */
      
      this.filtrirajLotove(e.value.ar_id);
    }
  
    filtrirajLotove(arId){
      //console.log(arId);
      this.sviLotovi_artikla = [];
      let vazido = '';
      for (let i = 0; i < this.sviLotovi_poslovnica.length; i++) {
        if (arId == this.sviLotovi_poslovnica[i].artikl_ar_id) {
  
          if(this.sviLotovi_poslovnica[i].ar_vazido != null){
            vazido = moment(this.sviLotovi_poslovnica[i].ar_vazido).format('DD.MM.YYYY');
          }else{
            vazido = '';
          }
  
          this.sviLotovi_artikla.push({
            ar_datum: this.sviLotovi_poslovnica[i].ar_datum,
            ar_lot: this.sviLotovi_poslovnica[i].ar_lot,
            ar_lotstanje: this.sviLotovi_poslovnica[i].ar_lotstanje,
            ar_sifra: this.sviLotovi_poslovnica[i].ar_sifra,
            ar_vazido: this.sviLotovi_poslovnica[i].ar_vazido,
            artikl_ar_id: this.sviLotovi_poslovnica[i].artikl_ar_id,
            firma_fi_id: this.sviLotovi_poslovnica[i].firma_fi_id,
            lb_datizmjene: this.sviLotovi_poslovnica[i].lb_datizmjene,
            lb_id: this.sviLotovi_poslovnica[i].lb_id,
            lot_id_adt: this.sviLotovi_poslovnica[i].lot_id_adt,
            po_sifra: this.sviLotovi_poslovnica[i].po_sifra,
            poslovnica_po_id: this.sviLotovi_poslovnica[i].poslovnica_po_id,
            ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno: moment(this.sviLotovi_poslovnica[i].ar_datum).format('DD.MM.YYYY') + ' - Rok: ' + vazido + ' ' + this.sviLotovi_poslovnica[i].ar_lot + ', ' + this.sviLotovi_poslovnica[i].ar_lotstanje_spojeno,
          });
        } 
      }
      //console.log('sviLotovi_artikla: ', this.sviLotovi_artikla); 
    }

  onChangeLot(e) {
    //console.log(e);
    this.lotBroj = e.value;
    //this.dohvatiSveLotove(this.idProizvoda);
  }

  onChangeKolicina(e) {
    //console.log(e);
    this.kolicina = e.value;
  }

  pdfMeduskladisnica(data){
    this.meduskladisnicaService.pdfMeduskladisnica(data);
  }

}
